import React from 'react';

const Donate = () => {
  return <h1 className="text-center">Donate Page</h1>;
};

export default Donate;
